import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type CtsModuleSpecsFragment } from '../../../../../api/fragments/CtsModuleSpecs';
import NoItemResult from '../../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../../utilities/hasPermissions';

export type CtsSettingsEmptyListProps = {
    module: CtsModuleSpecsFragment;
    openCtsSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const CtsSettingsEmptyList = ({ module, openCtsSettingDrawer, permissions }: CtsSettingsEmptyListProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);
    const { hasUpdatePermission } = permissions;

    return (
        <NoItemResult
            extra={
                hasUpdatePermission && (
                    <Button htmlType="button" loading={false} onClick={openCtsSettingDrawer} type="primary">
                        {t('ctsModuleDetails:settings.noData.action')}
                    </Button>
                )
            }
            subTitle={t('ctsModuleDetails:settings.noData.message')}
        />
    );
};

export default CtsSettingsEmptyList;
